import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_KEEPZ_URL || "";

export const conversionApi = createApi({
    reducerPath: "conversionApi",

    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            headers.set("Content-Type", "application/json");
            headers.set("Accept", "application/json");
            headers.set("channel-name", process.env.REACT_APP_CASH_CHANNEL_NAME || "");
            headers.set("authorization", `Bearer ${process.env.REACT_APP_CASH_TOKEN}`);
            return headers;
        },
    }),

    tagTypes: ["Cities", "Products", "Rates"],

    endpoints: (builder) => ({
        /* -------- Cities -------- */
        getCities: builder.query<any[], void>({
            query: () => "/api/Conversion/GetCities",
            transformResponse: (res: any) => res?.data?.data || [],
            providesTags: ["Cities"],
            keepUnusedDataFor: 60 * 60, // 🧠 1 საათი cache
        }),

        /* -------- Products -------- */
        getProducts: builder.query<any[], boolean>({
            query: (isCash) =>
                `/api/Conversion/GetProducts?IsCash=${isCash}`,
            transformResponse: (res: any) => res?.data?.data || [],
            providesTags: ["Products"],
            keepUnusedDataFor: 30 * 60,
        }),

        /* -------- Rates -------- */
        getRatesByProduct: builder.query<
            any,
            {
                isCash: boolean;
                RateProductID?: number;
                RateCityID?: number;
                tab?: number;
            }
        >({
            query: ({ isCash, RateProductID, RateCityID }) => {
                const params = new URLSearchParams();

                params.append("IsCash", String(isCash));

                if (RateProductID !== undefined) {
                    params.append("RateProductID", String(Number(RateProductID)));
                }

                if (RateCityID !== undefined) {
                    params.append("RateCityID", String(Number(RateCityID)));
                }

                return `/api/Conversion/GetWebRateByProductID?${params.toString()}`;
            },

            transformResponse: (res: any) => res?.data?.data,
            providesTags: ["Rates"],
        }),


        getRates: builder.query<any[], void>({
            query: () => `/api/keepz/getDefaultRates`,
            transformResponse: (res: any) => res?.data?.data || [],
            providesTags: ["Rates"],
        }),
    }),
});

export const {
    useGetCitiesQuery,
    useGetProductsQuery,
    useLazyGetRatesByProductQuery,
    useGetRatesQuery,
} = conversionApi;
